/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: 'Tono de llamada 1',
  [RINGS_TYPE.Phone_Ring2]: 'Tono de llamada 2',
  [RINGS_TYPE.Acoustic_Dreams]: 'Sueños acústicos',
  [RINGS_TYPE.Air_Raid]: 'Ataque aéreo',
  [RINGS_TYPE.Allusive]: 'Alusivo',
  [RINGS_TYPE.Attention]: 'Atención',
  [RINGS_TYPE.Blub_Blub]: 'Burbuja',
  [RINGS_TYPE.Buzzy]: 'Zumbido',
  [RINGS_TYPE.Channel_Open]: 'Canal abierto',
  [RINGS_TYPE.Contemplation]: 'Contemplación',
  [RINGS_TYPE.Crystal_Ball]: 'Bola de cristal',
  [RINGS_TYPE.Disco]: 'Disco',
  [RINGS_TYPE.Door_Bell]: 'Timbre',
  [RINGS_TYPE.Fairy]: 'Hada',
  [RINGS_TYPE.Fast_Bells]: 'Campanas rápidas',
  [RINGS_TYPE.High_Gong]: 'Gong alto',
  [RINGS_TYPE.Immersion]: 'Inmersión',
  [RINGS_TYPE.Indeed]: 'Seguro',
  [RINGS_TYPE.Lazy_Day]: 'Relax',
  [RINGS_TYPE.Neural_Funk]: 'Funk neural',
  [RINGS_TYPE.Nice]: 'Agradable',
  [RINGS_TYPE.Ring]: 'Ring',
  [RINGS_TYPE.Ringing_Bells]: 'Campanas',
  [RINGS_TYPE.Simple]: 'Simple',
  [RINGS_TYPE.Soothing]: 'Reconfortante',
  [RINGS_TYPE.Sunshine]: 'Brillo del sol',
  [RINGS_TYPE.Off]: 'Desactivado',
  add: 'Agregar',
  delete: 'Eliminar',
  play: 'Reproducir',
  cancel: 'Cancelar',
  confirmToDelete: '¿Desea eliminar {name}?',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
